import * as React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// Data Table Custom total design
const customTotal = (from: string, to: string, size: string) => (
  <span className="react-bootstrap-table-pagination-total pl-2">
    Showing {from} to {to} of {size} Results
  </span>
);

/** 
 * Pagination number
*/
let t = 0;
const pageButtonRenderer = (props: any) => {
  let key = t++;
  let classNames = "page-item";
  let araiText = "page";

  if( props.disabled)  classNames = "disabled " + classNames;
  if( props.active)  classNames = "active " + classNames;

  // if the page text is not a number we need to add aria text
  if( !Number.isInteger(props.page)) araiText = props.title;

  const handleClick = (e:any) => {
    e.preventDefault();
    if( props.onPageChange ) props.onPageChange(props.page);
  };
 
  return (

    // removed href="#"
    <li className={classNames} key={"p" + key} title={props.title}>    
      <a key={"pa" + key} href={"pa" + key} className="page-link" onClick={ handleClick } aria-disabled={props.disabled}> 
        <span className="hideVisually">{araiText} </span>{ props.page }
      </a>
    </li>
  );
};

// Pagination Customization
const pagination = paginationFactory({
  paginationTotalRenderer: customTotal,
  alwaysShowAllBtns: true,
  showTotal: true,
  pageButtonRenderer: pageButtonRenderer
});

class BasicTable extends React.Component<any, any> {

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDownEnter);
  }

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDownEnter);
  }

  componentDidUpdate(prevProps: any) {
    
  }

  handleKeyDownEnter(event: KeyboardEvent) {
    // check event
    if( event && event.target )
    {
      // TS needs
      const target: HTMLElement = event.target as HTMLElement;
      // if not the header, we dont care
      if( ( event.target as Element ).tagName === "TH" && !target.classList.contains('sortable') ) return;

      // activate sort
      if (event.keyCode === 13) {
        target.click()
      }
    }

  }

  selfRefrence( instance: any){
    
  }

  render() {

    return (
      <React.Fragment>
        <BootstrapTable
          bootstrap4
          ref={ this.selfRefrence }
          {...this.props}
          pagination={pagination}
          noDataIndication="No Data Available"
          overlay={overlayFactory({
            spinner: true,
            background: "rgba(192,192,192,0.3)",
            text: "Loading your content...",
            color: "red"
          })}
          //filter={ filterFactory() }
          striped
          hover
        />
      </React.Fragment>
    );
  }
}

export default BasicTable;